import React, { useEffect, useMemo, useRef, useState } from "react";

import CloseIcon from "../../assets/images/close.png";


import { TfiTrash } from "react-icons/tfi";
import { Disable } from 'react-disable';
import { TfiClose, TfiTag } from "react-icons/tfi";
import { TfiCalendar, TfiUser } from "react-icons/tfi";


import { connect } from "react-redux";
import { compose } from "redux";


import { getFinding, addAttachmentAction, editAction, getActionDetails, addActionComment } from "../../store/actions/riskActions";
import { getUsers } from "../../store/actions/adminActions";
import Select, { components } from "react-select";

import moment from 'moment';
import debounce from "lodash/debounce";




const FindingOverlay = (props) => {

    const { finding, finding_id, getFindingFN, closeFinding, onSave } = props;




    const [form, setForm] = useState({
        id: "",                 // derived from finding_id + year
        title: "",
        priority: "Medium",     // not in DB; pick a sensible default
        status: "Open",         // maps from DB (Open | Closed | Problem)
        finding_date: "",       // yyyy-mm-dd
        due_date: "",           // not in DB yet
        assigned_to: "",        // not in DB yet
        category: "",           // not in DB yet
        description: "",
        root_cause: "",
        impact: "",
        recommendation: "",
        control_title: ""
    });

    const badgeColor = {
        High: "bg-amber-100 text-amber-800 border-amber-300",
        Medium: "bg-yellow-100 text-yellow-800 border-yellow-300",
        Low: "bg-green-100 text-green-800 border-green-300",
        Urgent: "bg-red-100 text-red-800 border-red-300",
    }[form.priority] || "bg-gray-100 text-gray-700 border-gray-300";

    const statusColor = {
        "In Progress": "bg-purple-100 text-purple-800 border-purple-300",
        Open: "bg-blue-100 text-blue-800 border-blue-300",
        Closed: "bg-green-100 text-green-800 border-green-300",
        Problem: "bg-rose-100 text-rose-800 border-rose-300",
    }[form.status] || "bg-gray-100 text-gray-700 border-gray-300";




    useEffect(() => {
        if (finding_id)
            getFindingFN(finding_id);

    }, [finding_id]);


    useEffect(() => {
        if (!finding) return;

        const year = finding.finding_date
            ? new Date(finding.finding_date).getFullYear()
            : new Date().getFullYear();

        setForm({
            id: `AUD-${year}-${String(finding.id).padStart(3, "0")}`,
            title: finding.title ?? "",
            priority: "Medium", // still filler until you add this to DB
            status: finding.status || "Open", // 'Open' | 'Closed' | 'Problem'
            finding_date: toDateInput(finding.finding_date), // -> 'YYYY-MM-DD'
            due_date: "",           // filler
            assigned_to: finding.owner_name || "",        // filler
            category: "",           // filler
            description: finding.description ?? "",
            root_cause: finding.root_cause ?? "",
            impact: finding.impact ?? "",
            recommendation: finding.recommendation ?? "",
            control_title: finding.control_title ?? "",
        });
    }, [finding]);


    const toDateInput = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    };


    return (
        <div className="fixed inset-0 z-[999] flex items-start justify-center bg-black/30">
            <div className="relative mt-6 w-[720px] max-w-[95vw] rounded-xl bg-white shadow-xl border border-gray-200">
                {/* Header */}
                <div className="flex items-start justify-between gap-4 p-5">
                    <div className="flex-1">
                        <input
                            className="w-full text-xl font-semibold text-gray-900 bg-transparent outline-none"
                            value={form.title}
                            onChange={(e) => setForm({ ...form, title: e.target.value })}
                        />
                        <div className="mt-1 text-xs text-gray-500">Finding ID: {form.id}</div>
                    </div>

                    <button
                        onClick={(e) => closeFinding(form, finding_id, e)}
                        className="ml-1 rounded-full p-1.5 hover:bg-gray-100 text-gray-500"
                        aria-label="Close"
                    >
                        <TfiClose className="w-4 h-4" />
                    </button>
                </div>

                {/* Meta grid */}
                <div className="grid grid-cols-2 gap-4 px-5">
                    {/* Row 1: Finding Date (left) */}
                    <div className="flex items-center gap-2">
                        <TfiCalendar className="w-4 h-4 text-gray-600 self-center translate-y-[1px]" />
                        <div className="flex-1">
                            <div className="text-xs text-gray-500">Finding Date</div>
                            <input
                                type="date"
                                className="mt-0.5 text-sm text-gray-900 bg-transparent outline-none cursor-pointer w-[130px] appearance-none"
                                value={form.finding_date}
                                onChange={(e) => setForm({ ...form, finding_date: e.target.value })}
                            />
                        </div>
                    </div>

                    {/* Row 1: Owner (right) */}
                    <div className="flex items-center gap-2">
                        <TfiUser className="w-4 h-4 text-gray-600 self-center translate-y-[1px]" />
                        <div className="flex-1">
                            <div className="text-xs text-gray-500">Owner</div>
                            <input
                                readOnly
                                className="mt-0.5 w-full text-sm text-gray-900 bg-transparent outline-none"
                                value={form.assigned_to || ""}
                            />
                        </div>
                    </div>

                    {/* Row 2: Status (left, under date) */}
                    <div className="flex items-center gap-3 pl-[26px]">
                        <label className="text-xs text-gray-500">Status</label>
                        <select
                            className="max-w-[130px] text-xs h-8 rounded-md border border-gray-200 bg-white px-2 pr-5
      text-gray-900 shadow-sm hover:border-gray-300 focus:outline-none focus:ring-0 focus:border-gray-400"
                            value={form.status || "Open"}
                            onChange={(e) => setForm({ ...form, status: e.target.value })}
                        >
                            <option value="Open">Open</option>
                            <option value="Problem">Problem</option>
                            <option value="Closed">Closed</option>
                        </select>
                    </div>

                    {/* Row 2: Control Title (right, under owner) */}
                    <div className="flex items-center gap-2">
                        <TfiTag className="w-4 h-4 text-gray-600 self-center translate-y-[1px]" />
                        <div className="flex-1">
                            <div className="text-xs text-gray-500">Control</div>
                            <input
                                readOnly
                                className="mt-0.5 w-full text-sm text-gray-900 bg-transparent outline-none"
                                value={form.control_title || ""}
                            />
                        </div>
                    </div>
                </div>




                <div className="mt-4 border-t border-gray-200" />

                {/* Sections */}
                <section className="px-5 py-4">
                    <h4 className="mb-2 text-sm font-semibold text-gray-800 flex items-center gap-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4 text-gray-700"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.6"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9v6m-3-3h6m-9 7h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                        </svg>
                        Description
                    </h4>
                    <textarea
                        rows={3}
                        className="w-full resize-y rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-900"
                        value={form.description}
                        onChange={(e) => setForm({ ...form, description: e.target.value })}
                    />
                </section>

                <div className="border-t border-gray-200" />

                <section className="px-5 py-4">
                    <h4 className="mb-2 text-sm font-semibold text-gray-800">Root Cause</h4>
                    <textarea
                        rows={3}
                        className="w-full resize-y rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-900"
                        value={form.root_cause}
                        onChange={(e) => setForm({ ...form, root_cause: e.target.value })}
                    />
                </section>

                <div className="border-t border-gray-200" />

                <section className="px-5 py-4">
                    <h4 className="mb-2 text-sm font-semibold text-gray-800">Impact</h4>
                    <textarea
                        rows={3}
                        className="w-full resize-y rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-900"
                        value={form.impact}
                        onChange={(e) => setForm({ ...form, impact: e.target.value })}
                    />
                </section>

                <div className="border-t border-gray-200" />

                <section className="px-5 py-4">
                    <h4 className="mb-2 text-sm font-semibold text-gray-800">Recommendation</h4>
                    <div className="rounded-xl border border-gray-200 bg-gray-50">
                        <textarea
                            rows={3}
                            className="w-full resize-y rounded-xl bg-gray-50 p-3 text-sm text-gray-900 outline-none"
                            value={form.recommendation}
                            onChange={(e) => setForm({ ...form, recommendation: e.target.value })}
                        />
                    </div>
                </section>
            </div>
        </div>
    );

};


const mapStateToProps = (state) => {
    console.log("Finding ", state.risk.control_details)
    return {

        finding: state.risk.control_details?.finding_details,

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addAttachmentActionFN: (risk_id, action_id, file) => dispatch(addAttachmentAction(risk_id, action_id, file)),
        editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
        getActionDetailsFN: (risk_id, action_id) => dispatch(getActionDetails(risk_id, action_id)),
        addActionCommentFN: (comment, action_id) => dispatch(addActionComment(comment, action_id)),
        getFindingFN: (finding_id) => dispatch(getFinding(finding_id)),
        getUsersFN: () => dispatch(getUsers()),

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(FindingOverlay);